import React from "react";
import { useSelector } from "react-redux";
import asset1 from "../../../assets/images/asset1.png";
import thumbnail from "../../../assets/images/thumbnail.png";
import getSymbolFromCurrency from "currency-symbol-map";

const OrderInfo = ({ order }) => {
  const { line_items, subtotal_price: totalPrice, currency } = order;
  const { order_details: i18n } = useSelector((state) => state.i18n);
  const products =
    typeof line_items === "string" ? JSON.parse(line_items) : line_items;
  const lineItems = products.filter((item) => item.product_id !== null);
  return (
    <div className="order-info">
      <p className="h2 order-info-title">{i18n.shipment_items}</p>
      <div className="order-info-contain">
        {lineItems?.map((product, index) => (
          <div key={index} className="row info-item">
            <div className="col-3 image-item">
              <img
                src={product.image ?? thumbnail}
                className="img-thumbnail"
                alt="..."
              ></img>
            </div>
            <div className="col-9">
              <div>
                <strong>{product?.title}</strong>
              </div>
              <div
                style={{ paddingRight: "24px" }}
                className="d-flex justify-content-between"
              >
                <div>
                  <span className="total-item">{product?.variant_title}</span>
                  <span className="price-item">
                    {product.quantity}{" "}
                    {product?.quantity > 1
                      ? i18n.item_plural
                      : i18n.item_singular}
                  </span>
                </div>
                <div>
                  <strong>
                    {getSymbolFromCurrency(currency)} {product?.price}
                  </strong>
                </div>
              </div>
            </div>
          </div>
        ))}
        <div className="row desc-item"></div>
      </div>
      <div className="row desc-item ">
        <div className="col-9 offset-3 end-item">
          <span className="total-item">{i18n.total_price}</span>
          <span className="price-item special-item">
            {getSymbolFromCurrency(currency)} {totalPrice}
          </span>
        </div>
      </div>
    </div>
  );
};

export default OrderInfo;
